import React, { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState("");
  const [email, setEmail] = useState("");
  const [id, setId] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    const role = localStorage.getItem("userRole");
    const id = localStorage.getItem("id");

    if (token && role) {
      setIsAuthenticated(true);
      setUserRole(role);
      setId(id);
      if (role === "Admin") {
        navigate("/admin");
      } else {
        navigate("/user");
      }
    }
  }, [navigate]);

  const login = (token, role, username, id) => {
    setIsAuthenticated(true);
    setUserRole(role);
    setEmail(username);
    setId(id);
    localStorage.setItem("jwtToken", token);
    localStorage.setItem("userRole", role);
    localStorage.setItem("user", username);
    localStorage.setItem("id", id);
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUserRole("");
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("userRole");
    localStorage.removeItem("user");
    localStorage.removeItem("id");
  };

  return (
    <AuthContext.Provider
      value={{ isAuthenticated, userRole, login, logout, email, id }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
